module.exports = {
  removeFirstAndLast (x) {
    return x.substring(1, x.length - 1)
  }
}



// WEBPACK FOOTER //
// ./src/parsing/helpers/tools.js